import React from "react";
import { Chart, ArcElement, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";

Chart.register(ArcElement, Tooltip);

const HealthScoreChart = ({ percentage, homepage, handleClickOpen }) => {
    const ratings = ["Good", "Mild", "Moderate", "Poor", "Severe", "Extreme"].reverse();
    const statusIndex = Math.min(Math.floor((percentage / 100) * ratings.length), ratings.length - 1);
    const status = ratings[statusIndex];

    const data = {
        datasets: [
            {
                data: [percentage, 100 - percentage],
                backgroundColor: ["#EEBC8F", "#E0E0E0"],
                borderWidth: 0,
                cutout: "70%",
            },
        ],
    };

    const options = {
        plugins: {
            tooltip: { enabled: false },
        },
        rotation: 225,
        circumference: 270,
    };

    return (
        <div className="flex flex-col items-center">
            <div className={`relative ${homepage ? 'w-50 h-40' : 'w-500 h-100'}`}>
                <Doughnut data={data} options={options} />

                <div className="absolute inset-0 flex items-center justify-center text-center mt-10">
                    <div>
                        <span className="text-xl font-semibold">{status}</span>
                        <p className="text-sm text-gray-500">Health Score</p>
                    </div>
                </div>
            </div>
            {!homepage &&
                <button className="mt-2 text-blue-500 hover:underline" onClick={handleClickOpen}>
                    View details &rarr;
                </button>}
        </div>
    );
};

export default HealthScoreChart;
